import {ActionCompletionDialogComponent} from '../../../common/action-completion-dialog/action-completion-dialog.component';
import {CommonService} from '../../../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import {SimpleConfirmActionDialogComponent} from '../../../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  templateUrl: './route-transfer-form.component.html'
})
export class RouteTransferFormComponent implements OnInit {
  @ViewChild(MatSort, {static: false}) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, {static: false}) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  public data: any;
  public dataSource: MatTableDataSource<any>;
  private sort: MatSort;
  private paginator: MatPaginator;
  public selection: SelectionModel<any>;

  public displayedColumns: string[] = [
    'select',
    'id',
    'applicant_sale_point_name',
    'applicant_sales_group_name',
    'recipient_sale_point_name'
  ];

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService) {
    this.data = [];
    this.dataSource = new MatTableDataSource<any>([]);
    this.selection = new SelectionModel<any>(true, []);
  }

  public async ngOnInit(): Promise<any> {
    this.data = await this.commonService.getSimpleList('refrigerator_transfer/web?filter=status_id=1');
    this.dataSource = new MatTableDataSource<any>(this.data);
    this.commonService.setPaginatorTexts(this.paginator);
  }

  public masterToggle(): void {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public isSubmitDisabled() {
    return this.selection.selected.length === 0;
  }

  public submit() {
    const ids = [];
    this.selection.selected.forEach(row => {
      ids.push(row.id);
    });
    const commandsText = ids.length === 1 ? `την επιλεγμένη εντολή` : `τις επιλεγμένες εντολές`
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Δρομολόγηση Εντολών',
        message: `Είστε σίγουροι ότι
        θέλετε να δρομολογήσετε ${commandsText};`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const response = await this.commonService.updateObject(`refrigerator_transfer/route`,
            {ids});
          if (response) {
            this.matDialog.open(ActionCompletionDialogComponent, {
              data: {
                buttonText: 'Πλοήγηση στις εντολές αλλημεταφοράς',
                redirectURL: `refrigerator_transfers`
              }
            });
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
